import { useEffect, useState } from 'react';
import SubHeading from '../../../Components/SubHeading';
import { BsFillCalendar2WeekFill } from 'react-icons/bs';
import { Calendar } from '../../../Components/Calendar';
import { useSelector } from 'react-redux';
import NepaliDate from 'nepali-date-converter';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { fetchWrapper } from '../../../_helpers/fetchWrapper';
import { Link } from 'react-router-dom';

function EventCalendar() {
  const lang = useSelector((state) => state.local.local);
  const [day, setDay] = useState(null);
  const [calendarData, setCalendarData] = useState([]);
  useEffect(() => {
    async function getEventCalendar() {
      try {
        const response = await fetchWrapper.get('/event/calendar/');
        setCalendarData(response.data);
      } catch (err) {
        console.log(err);
      }
    }

    getEventCalendar();
  }, []);
  const events = calendarData.reduce(
    (obj, item) => Object.assign(obj, { [item.date]: item.events }),
    {}
  );
  const handleDateClick = (day) => {
    setDay(day);
  };
  return (
    <div className="card content-section p-3">
      <div className="card-header">
        <SubHeading id="sidebar.event_calendar" Icon={BsFillCalendar2WeekFill} />
      </div>
      <hr />
      <div className="row">
        <div className="col-6">
          <Calendar
            language={lang === 'ne' ? lang : 'en'}
            events={events}
            onDateClicked={handleDateClick}
          />
        </div>
        <div className="col-6">
          <h3 className="text-primary ">
            {
              new NepaliDate(day?.date_np || new Date()).format(
                'ddd DD, MMMM YYYY',
                lang === 'ne' ? 'np' : 'en'
              ) // 'आइतबार १०, फाल्गुण २०५४'
            }
          </h3>
          <h4 className="mt-2">
            <FormattedMessage id="Events" />
          </h4>

          <StyledEventContainer className="p-2 border rounded">
            {day && day.events ? (
              day.events.map((event) => (
                <StyledEvent key={event.id}>
                  <div className="d-flex align-items-start">
                    <h4 className="text-primary">
                      <Link to={`/admin/events/${event.id}`}>
                        {' '}
                        {lang === 'ne' ? event.title_nepali : event.title_english}
                      </Link>
                    </h4>
                    <div className="ms-3 badge bg-success">{event.program_type}</div>
                  </div>
                  <div className="d-flex justify-content-between w-50 my-2">
                    <span>
                      <FormattedMessage id="calendar.start_date" /> :{' '}
                      {new NepaliDate(new Date(event.start_date)).format(
                        'YYYY/MM/DD',
                        lang === 'ne' ? 'np' : 'en'
                      )}{' '}
                    </span>
                    <span>
                      <FormattedMessage id="calendar.end_date" /> :{' '}
                      {new NepaliDate(new Date(event.end_date)).format(
                        'YYYY/MM/DD',
                        lang === 'ne' ? 'np' : 'en'
                      )}{' '}
                    </span>
                  </div>
                </StyledEvent>
              ))
            ) : (
              <div className="d-flex justify-content-center align-items-center h-100 w-100">
                <h4>
                  <FormattedMessage id="calendar.no_event" />
                </h4>
              </div>
            )}
          </StyledEventContainer>
        </div>
      </div>
    </div>
  );
}

export default EventCalendar;

const StyledEvent = styled.div`
  padding: 1rem 2rem;
  border: 1px solid gray;
  border-radius: 10px;
  margin-bottom: 1rem;
  h4 {
    font-weight: 500;
  }
`;

const StyledEventContainer = styled.div`
  max-height: 565px;
  height: 100%;
  overflow-y: auto;
`;
